import React, { useState } from 'react';
import { createUrl } from '../utils';

async function sha256Hex(text) {
  const data = new TextEncoder().encode(text);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer)).map(b => b.toString(16).padStart(2, '0')).join('');
}

function HiddenContent() {
  const [secret, setSecret] = useState('');
  const [videoInfo, setVideoInfo] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const hashed = await sha256Hex(secret);
      const videoUrl = createUrl(`/hidden-content-video?secret=${encodeURIComponent(hashed)}`);
      const res = await fetch(videoUrl, { method: 'HEAD' });
      if (res.ok) {
        setVideoInfo({ videoName: "AXA Decumulation Video", videoUrl });
      } else {
        setError('Incorrect secret. Please try again.');
      }
    } catch {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      {!videoInfo ? (
        <div className="bg-white rounded-2xl shadow-lg p-10 w-full max-w-md">
          <h1 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Protected Content</h1>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input
              type="password"
              placeholder="Enter secret"
              value={secret}
              onChange={(e) => setSecret(e.target.value)}
              className="border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-red-400"
              required
            />
            {error && <p className="text-red-500 text-sm text-center">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg py-3 transition-colors disabled:opacity-50"
            >
              {loading ? 'Verifying...' : 'Access'}
            </button>
          </form>
        </div>
      ) : (
        <div className="w-full max-w-4xl flex flex-col items-center gap-6">
          <h1 className="text-2xl font-semibold text-gray-800">{videoInfo.videoName}</h1>
          <video
            className="w-full rounded-2xl shadow-lg"
            controls
            autoPlay
            src={videoInfo.videoUrl}
            onContextMenu={(e) => e.preventDefault()}
            controlsList="nodownload"
          >
            Your browser does not support the video tag.
          </video>
        </div>
      )}
    </div>
  );
}

export default HiddenContent;
